(function ($) {
    if ($('.page-template-template-network-map').length) {
        var map, autocomplete, mapCenter, mapMarkers = [], defaultZoomLevel = 7, defaultIconScale = 1, scaledIconSize;

        if (window.matchMedia("(max-width: 730px)").matches) {
            if ($('.page-template-template-network-map').length) {
                defaultZoomLevel = 6;
                defaultIconScale = 0.65
                scaledIconSize = new google.maps.Size(21.45, 27.3)
            }
        }

        function resetBounce() {
            for (var i = 0; i < mapMarkers.length; i++) {
                mapMarkers[i].setAnimation(null);
            }
        }

        function toggleBounce() {
            resetBounce();

            if (this.getAnimation() !== null) {
                this.setAnimation(null);
            } else {
                this.setAnimation(google.maps.Animation.BOUNCE);
            }
        }

        function centerMap() {
            map.setCenter(mapCenter);
        }

        function resetMap() {
            map.setCenter(mapCenter);
            map.setZoom(defaultZoomLevel);
            resetBounce();
        }

        function zoomToMarker(title) {
            var targetMarkerIndex = 0;

            $(mapMarkers).each(function (index, el) {
                if (this.title === title) {
                    targetMarkerIndex = index;
                }
            });

            map.setZoom(10);
            map.setCenter(mapMarkers[targetMarkerIndex].getPosition());

            resetBounce();
            mapMarkers[targetMarkerIndex].setAnimation(google.maps.Animation.BOUNCE);
        }

        function zoomToRegion(region) {
            resetBounce();

            var markerIndexes = [];

            $('.map-contact-block').removeClass('active');

            $(mapMarkers).each(function (index, el) {
                if (this.region === region) {
                    markerIndexes.push(index);
                }
            });

            if (markerIndexes.length === 1) {
                map.setZoom(10);
                map.setCenter(mapMarkers[markerIndexes[0]].getPosition());
            } else {
                var bounds = new google.maps.LatLngBounds();
                for (var i = 0; i < markerIndexes.length; i++) {
                    bounds.extend(mapMarkers[markerIndexes[i]].getPosition());
                }

                map.setCenter(bounds.getCenter());
                map.panToBounds(bounds)
                map.fitBounds(bounds);
            }
        }

        function scrollToContactBlock(title) {
            var contactBlock = $('.map-contact-block[data-title="' + title + '"]');
            var searchCategory = contactBlock.data('category');
            var categories = $('.map-filters .category-selection.active').map(function () {
                return $(this).data('category');
            }).get();

            $('.map-contact-block').removeClass('active');

            if (!categories.includes(searchCategory)) {
                $('.map-filters .category-selection[data-category="' + searchCategory + '"]').click();
                $('.map-filters .region-search').val(title);
            }

            if (window.matchMedia("(max-width: 1230px)").matches) {
                $('html, body').animate({
                    scrollTop: $('.map-contacts')[0].offsetTop
                }, 500);
            }

            $('.map-contacts .simplebar-content-wrapper').animate({
                scrollTop: contactBlock[0].offsetTop
            }, 500);

            contactBlock.addClass('active');
        }

        function map() {
            function initialize() {
                mapCenter = new google.maps.LatLng(mapLat, mapLng);

                var agrochemaIcon = {
                    path: "M16.5 0C7.40185 0 0 6.8104 0 15.1815C0 25.5703 14.7659 40.8216 15.3946 41.4658C15.9851 42.0709 17.016 42.0698 17.6054 41.4658C18.2341 40.8216 33 25.5703 33 15.1815C32.9998 6.8104 25.5981 0 16.5 0ZM27 15.5C27 21.299 22.299 26 16.5 26C10.701 26 6 21.299 6 15.5C6 9.70101 10.701 5 16.5 5C22.299 5 27 9.70101 27 15.5ZM15.7616 10.2337C16.0421 9.80412 16.3127 9.38979 16.5367 9C16.7207 9.50506 17.135 10.1371 17.5777 10.8124C18.3289 11.9582 19.1618 13.2289 19.0909 14.2162V14.2269C19.0909 14.836 18.8061 15.3893 18.3438 15.791C17.8786 16.1953 17.2358 16.4453 16.5254 16.4453C15.8149 16.4453 15.1721 16.1953 14.707 15.791C14.2474 15.392 13.9599 14.8387 13.9599 14.2322C14.0021 12.9278 14.926 11.5132 15.7616 10.2337ZM18.5778 16.0277C19.074 15.5941 19.3954 15.0089 19.432 14.3572C19.4602 14.3546 19.4912 14.3546 19.525 14.3572H19.5335C20.4505 14.3058 21.4341 14.8322 22.4299 15.3651C23.2892 15.8251 24.1576 16.2898 25 16.3921C24.6056 16.592 24.1919 16.8274 23.7649 17.0704C22.4187 17.8367 20.9406 18.6779 19.5194 18.7143C18.8597 18.7143 18.262 18.4696 17.8279 18.0732C17.4388 17.7194 17.1823 17.2433 17.1343 16.714C17.6897 16.6102 18.1887 16.3655 18.5778 16.0277ZM13.5807 14.3559C13.5955 14.3566 13.6103 14.3572 13.6244 14.3572C13.661 15.0063 13.9796 15.5941 14.4814 16.025C14.8705 16.3655 15.3695 16.6076 15.9277 16.7113C15.8798 17.2407 15.6232 17.7168 15.2342 18.0706C14.8 18.4669 14.1995 18.7116 13.5398 18.7116C11.9184 18.6679 10.1198 17.6095 8.65841 16.7495C8.43006 16.6151 8.20993 16.4856 8 16.3655C8.67179 16.1835 9.42076 15.8281 10.1837 15.466C11.3387 14.9179 12.5257 14.3546 13.5257 14.3546H13.537C13.5511 14.3546 13.5659 14.3552 13.5807 14.3559Z",
                    fillColor: "#017535",
                    fillOpacity: 1,
                    anchor: new google.maps.Point(16.5, 41.92),
                    strokeWeight: 0,
                    scale: defaultIconScale
                }

                var agromaxIcon = {
                    url: postmpwp.template_directory + "/assets/images/map-agromax.png",
                    anchor: new google.maps.Point(16.5, 41.92),
                    scaledSize: scaledIconSize
                }

                var nuomojamiElevatoriaiIcon = {
                    path: "M16.5 0C7.40185 0 0 6.8104 0 15.1815C0 25.5703 14.7659 40.8216 15.3946 41.4658C15.9851 42.0709 17.016 42.0698 17.6054 41.4658C18.2341 40.8216 33 25.5703 33 15.1815C32.9998 6.8104 25.5981 0 16.5 0ZM27 15.5C27 21.299 22.299 26 16.5 26C10.701 26 6 21.299 6 15.5C6 9.70101 10.701 5 16.5 5C22.299 5 27 9.70101 27 15.5ZM11.1753 8H11V8.17526V21.3532H11.3505V8.35053H13.9992V8.6459H14.2736L12.1164 11.2344V21.3532H16.8228V11.2344L14.6657 8.6459H14.9404V8.35053H19.1761V8.6459H19.4507L17.2936 11.2344V21.3532H22V11.2344L19.8428 8.6459H20.1174V8.35053H20.1174V8H14.7521H11.1753Z",
                    fillColor: "#CBA64E",
                    fillOpacity: 1,
                    anchor: new google.maps.Point(16.5, 41.92),
                    strokeWeight: 0,
                    scale: defaultIconScale
                }

                var supirkimasUostoseIcon = {
                    path: "M16.5 0C7.40185 0 0 6.8104 0 15.1815C0 25.5703 14.7659 40.8216 15.3946 41.4658C15.9851 42.0709 17.016 42.0698 17.6054 41.4658C18.2341 40.8216 33 25.5703 33 15.1815C32.9998 6.8104 25.5981 0 16.5 0ZM27 15.5C27 21.299 22.299 26 16.5 26C10.701 26 6 21.299 6 15.5C6 9.70101 10.701 5 16.5 5C22.299 5 27 9.70101 27 15.5ZM20.474 8.28922V8L20.194 8.07258L13.444 9.82258L13.2764 9.86604V10.0392V12.2892H13.724V10.2629H19.4378L18.5769 17.7892H17.4999V22.2892H22.9999V17.7892H21.922L21.0611 10.2629H22.5002V9.81526H20.474V8.28922ZM20.0264 9.81526V8.57843L15.2557 9.81526H20.0264ZM10 16.9663L11.5 20.7163H15.5L17 16.9663H10ZM13.6242 21.6964C13.8338 21.5566 14.3806 21.3662 14.8759 21.6964C15.5806 22.1664 16.3338 21.89 16.6242 21.6964C16.727 21.6279 16.7548 21.4889 16.6862 21.3861C16.6177 21.2832 16.4787 21.2555 16.3759 21.324C16.1662 21.4638 15.6194 21.6542 15.1242 21.324C14.4194 20.8541 13.6663 21.1304 13.3759 21.324C13.1662 21.4638 12.6194 21.6542 12.1242 21.324C11.4194 20.8542 10.6662 21.1304 10.3759 21.324C10.273 21.3926 10.2453 21.5315 10.3138 21.6344C10.3824 21.7372 10.5213 21.765 10.6242 21.6964C10.8338 21.5567 11.3806 21.3663 11.8759 21.6964C12.5806 22.1663 13.3338 21.89 13.6242 21.6964L13.6242 21.6964ZM18.9993 20.289H18.4993V20.789H18.9993V20.289ZM19.9998 20.289H20.4998V20.789H19.9998V20.289ZM21.9999 20.289H21.4999V20.789H21.9999V20.289ZM13.0001 12.2894H14.0001V12.789H15.0001V14.7889H12.0001V12.789H13.0001V12.2894ZM11 15.9663H12.5V16.9663H11V15.9663Z",
                    fillColor: "#6F7597",
                    fillOpacity: 1,
                    anchor: new google.maps.Point(16.5, 41.92),
                    strokeWeight: 0,
                    scale: defaultIconScale
                }

                var supirkimoAikstelesIcon = {
                    path: "M16.5 0C7.40185 0 0 6.8104 0 15.1815C0 25.5703 14.7659 40.8216 15.3946 41.4658C15.9851 42.0709 17.016 42.0698 17.6054 41.4658C18.2341 40.8216 33 25.5703 33 15.1815C32.9998 6.8104 25.5981 0 16.5 0ZM27 15.5C27 21.299 22.299 26 16.5 26C10.701 26 6 21.299 6 15.5C6 9.70101 10.701 5 16.5 5C22.299 5 27 9.70101 27 15.5ZM11 22V12.6667L16.7377 8L22.4754 12.6667V22H21.3279V15.1373H12.1475V22H11ZM20.4668 16.6596H13.0078V15.8111H20.4668V16.6596ZM13.0078 18.3066H20.4668V17.4581H13.0078V18.3066ZM20.4668 19.9535H13.0078V19.1051H20.4668V19.9535ZM13.0078 21.6005H20.4668V20.752H13.0078V21.6005Z",
                    fillColor: "#68B92E",
                    fillOpacity: 1,
                    anchor: new google.maps.Point(16.5, 41.92),
                    strokeWeight: 0,
                    scale: defaultIconScale
                }

                var mapOptions = {
                    zoom: defaultZoomLevel,
                    maxZoom: 16,
                    styles: [
                        {
                            "featureType": "landscape",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#eaf5f3"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.highway",
                            "elementType": "geometry.stroke",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.arterial",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "road.local",
                            "elementType": "geometry.fill",
                            "stylers": [
                                {
                                    "color": "#ffffff"
                                }
                            ]
                        },
                        {
                            "featureType": "water",
                            "elementType": "all",
                            "stylers": [
                                {
                                    "color": "#a1c2e6"
                                }
                            ]
                        }
                    ]
                };

                map = new google.maps.Map(document.getElementById("gmap"), mapOptions);

                function setMarkers() {
                    for (var i = 0; i < markers.length; i++) {
                        var categoryIcon;

                        switch (markers[i].category) {
                            case "agrochema":
                                categoryIcon = agrochemaIcon;
                                break;
                            case "agromax":
                                categoryIcon = agromaxIcon;
                                break;
                            case "agrochema_elevatoriai":
                                categoryIcon = agrochemaIcon;
                                break;
                            case "nuomojami_elevatoriai":
                                categoryIcon = nuomojamiElevatoriaiIcon;
                                break;
                            case "supirkimo_aiksteles":
                                categoryIcon = supirkimoAikstelesIcon;
                                break;
                            case "supirkimas_uostose":
                                categoryIcon = supirkimasUostoseIcon;
                                break;
                        }

                        var marker = new google.maps.Marker({
                            position: new google.maps.LatLng(markers[i].lat, markers[i].lng),
                            map: map,
                            animation: google.maps.Animation.DROP,
                            icon: categoryIcon,
                            category: markers[i].category,
                            title: markers[i].title,
                            region: markers[i].region
                        })

                        marker.addListener("click", toggleBounce);

                        google.maps.event.addListener(marker, 'click', function () {
                            scrollToContactBlock(this.title);
                        })

                        mapMarkers.push(marker);
                    }
                }

                setMarkers();

                google.maps.event.addDomListener(window, 'resize', centerMap());
                google.maps.event.trigger(map, 'resize');
            }

            google.maps.event.addDomListener(window, 'load', initialize)
        }

        map();

        $('.map-filters .category-selection').on('click', function () {
            $(this).toggleClass('active');

            var categories = $('.map-filters .category-selection.active').map(function () {
                return $(this).data('category');
            }).get();

            if (!$(this).hasClass('active')) {
                if (categories.length === 1) {
                    $('.map-filters .category-selection.active').addClass('disabled');
                }
            } else {
                $('.map-filters .category-selection').removeClass('disabled');
            }

            for (var i = 0; i < mapMarkers.length; i++) {
                if (!categories.includes(mapMarkers[i].category)) {
                    mapMarkers[i].setVisible(false);
                } else {
                    mapMarkers[i].setVisible(true);
                }
            }

            $('.map-contact-block').each(function (index, el) {
                $(el).removeClass('active');

                if (!categories.includes($(el).data('category'))) {
                    $(el).hide();
                } else {
                    $(el).show();
                }
            });

            $('.map-filters .region-search').val('');
            $('.map-filters .region-select').val('').trigger('change');

            resetMap();
        });

        $('.map-filters .region-select').each(function (index, el) {
            $(this).select2({
                closeOnSelect: true,
                minimumResultsForSearch: $(this).data('search-results'),
                placeholder: $(this).data('input-placeholder')
            })

            $(this).on('select2:select', function () {
                $('.map-filters .region-search').val('');
                zoomToRegion($(this).val());
            });
        });

        $('.map-contacts .map-contact-block').on('click', function() {
           var title = $(this).data('title');

            $('.map-contact-block').removeClass('active');
            $(this).addClass('active');
            zoomToMarker(title);

            if (window.matchMedia("(max-width: 1230px)").matches) {
                $('html, body').animate({
                    scrollTop: ($('.map-wrapper')[0].offsetTop - $('header').outerHeight())
                }, 500);
            }
        });

        autocomplete = new autoComplete({
            selector: '.map-filters .region-search',
            delay: 0,
            minChars: 1,
            source: function (term, suggest) {
                term = term.toLowerCase();
                var matches = [];

                for (i = 0; i < titles.length; i++) {
                    if (~titles[i].toLowerCase().indexOf(term)) {
                        matches.push(titles[i]);
                    }
                }
                suggest(matches);
            },
            onSelect: function (e, term, item) {
                scrollToContactBlock($(item).data('val'));
                $('.map-filters .region-select').val('').trigger('change');

                zoomToMarker($(item).data('val'));
            }
        });
    }
})(jQuery);